import { ApplicationConfig, LOCALE_ID, importProvidersFrom, CSP_NONCE } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { OAuthModule } from 'angular-oauth2-oidc';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { headerInterceptor } from './modules/shared/interceptors/header-interceptor';
import { loaderInterceptor } from './modules/shared/interceptors/loader.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['https://localhost:4200/api', 'https://localhost:5000/api', 'https://localhost:5005/api'],
        sendAccessToken: true
      }
    })),
    provideHttpClient(
      withXhr(),
      withInterceptors([headerInterceptor, loaderInterceptor]),
    ),
    {
      provide: LOCALE_ID,
      useValue: "es-Ar"
    },
    provideRouter(routes),
    provideAnimations(),
    provideToastr(),
    {
      provide: CSP_NONCE,
      useFactory: () => document.body?.getAttribute('ngCspNonce') ?? null
    }
  ]
};
